import { Component } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ICON } from '@core/util/icon';
import { MergedMatterDocumentSelectors } from '@state/global/documents/merged-documents';
import { TestHooks } from './documents-nav-bar.hooks';

@Component({
	selector: 'app-documents-nav-bar',
	templateUrl: './documents-nav-bar.component.html',
	standalone: false,
})
export class DocumentsNavBarComponent {
	public showDocumentsDropdown = false;
	public ICON = ICON;
	public testHooks = TestHooks;

	@Select(MergedMatterDocumentSelectors.getDocumentCount)
	documentCount$: Observable<number>;
}
